import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Play = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M17.7209 10.6976L8.24421 5.2824C7.24422 4.71098 6 5.43304 6 6.58477V17.4152C6 18.567 7.24422 19.289 8.24421 18.7176L17.7209 13.3024C18.7286 12.7265 18.7286 11.2735 17.7209 10.6976Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M8.51811 4.34311C6.98166 3.40677 5 4.49726 5 6.27908V17.7209C5 19.5027 6.98166 20.5932 8.51811 19.6569L17.9057 13.936C19.3648 13.0468 19.3648 10.9532 17.9057 10.064L8.51811 4.34311Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
